<template>
  <div class="share_container">
    <div class="share_backbox">
      <div class="share_background"></div>
    </div>

    <div class="share_btn_group">
      <!-- 微信好友 -->
      <div v-if="isWeiXin" class="share_button" @touchstart="setShareStatus(true)">
        <div class="share_bg wechat_friends"></div>
        <span class="txt">微信好友</span>
      </div>

      <!-- 朋友圈 -->
      <div class="share_button" @touchstart="setShareStatus(true, 'moments')">
        <div class="share_bg wechart_moments"></div>
        <span class="txt">朋友圈</span>
      </div>

      <!-- 复制链接 -->
      <div class="share_button" @click="copyLink">
        <div class="share_bg link"></div>
        <span class="txt">复制链接</span>
      </div>
    </div>

    <!-- 模态框 -->

    <div class="share_common_modal">
      <div class="wechat_share_friend_tips" v-show="shareFriends">
        <div class="inner">
          <div class="close_share_tips" @touchstart="setShareStatus(false)"></div>
        </div>
      </div>
      <div
        v-show="startShare"
        class="modal_backdrop"
        @touchstart.self="setShareStatus(false, 'moments')"
      >
        <div class="poster_modal">
          <div
            v-loading="!posterDataUrl"
            element-loading-text="生成图片中"
            element-loading-background="rgba(255, 255, 255, 1)"
            class="poster_img_loading"
            v-if="!posterDataUrl"
          ></div>
          <img v-else class="poster_img" :src="posterDataUrl" alt />
          <p class="poster_tips"># 长按图片保存至手机后发朋友圈分享给好友 #</p>
        </div>
      </div>
    </div>

    <!-- 分享到朋友圈生成海报 -->
    <div class="place_container">
      <div class="poster_container" id="poster">
        <div style="height: 12px;"></div>
        <div class="poster_header">
          <div class="left"></div>
          <div class="right">
            <p>
              <span class="ft_bold">云图报告用户&nbsp;&nbsp;</span>
              <span>向你推荐了一个幻灯片</span>
            </p>
            <p class="one_line_hidden">由{{userInfo.username}}用户创建&nbsp;/&nbsp;共{{pages.length}}页</p>
          </div>
        </div>
        <div class="poster_content">
          <div class="qrcode_box">
            <p>长按识别</p>
            <vue-qr class="qrcode" :margin="5" :text="text" :size="100" :logoSrc="logoSrc"></vue-qr>
          </div>
        </div>
        <div class="poster_bottom">
          <img class="logo inline_block" src="/favicon.png" alt />
          <div class="inline_block f12">云图报告</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tools from "@/utils/tools.js";
import Api from "@/api/report/index.js";
import VueQr from "vue-qr";
import html2canvas from "html2canvas";
import clipboard from "@/utils/clipboard";

let isWeiXin = Tools.isWeiXin();
export default {
  components: { VueQr },
  data() {
    return {
      text: "",
      logoSrc: "/favicon.png",
      startShare: false,
      posterDataUrl: "",
      id: this.$route.query.id || 0,
      city: this.$route.query.city || "",
      shareToken: this.$route.query.token || "",
      pages: [],
      info: {},
      userInfo: {},
      isWeiXin,
      shareFriends: false
    };
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.getUserInfo();
      this.loadData();
    },
    async getUserInfo() {
      let res = await Api.getUserInfo();
      if (res.status) {
        this.userInfo = res.data;
      }
    },

    async loadData() {
      if (!this.id) {
        bi.message({
          tipText: "报告ID不存在",
          type: "error"
        });
        return;
      }
      let res = await Api.loadReport({ id: this.id });
      if (res.status) {
        let { data = {}, info = {} } = res.data;
        if (data) {
          this.pages = data.pages || [];
        }
        this.info = info;
        bi.gShare.shareTitle = `${info.name}-云图报告`;
        if (!bi.gShare.href) {
          bi.gShare.href = `${location.origin}${location.pathname}#/report/mobile/show?id=${this.id}&city=${this.city}&token=${this.shareToken}`;
        }
        Tools.wx_share();
        this.copyShareLink();
      }
    },
    // 复制分享链接
    copyShareLink() {
      this.text = `${location.origin}${
        location.pathname
      }#/report/mobile/show?id=${this.id}&city=${encodeURI(this.city)}&token=${
        this.shareToken
      }`;
    },

    async copyLink() {
      if (!this.text) {
        this.copyShareLink();
      }
      clipboard.copy(
        `${location.origin}${location.pathname}#/report/mobile/show?id=${this.id}&city=${this.city}&token=${this.shareToken}`
      );

      bi.message({
        tipText: "复制链接成功",
        type: "success",
        duration: 1000
      });
    },

    setShareStatus(status, type = "") {
      if (type == "moments") {
        if (!this.posterDataUrl) {
          this.createPoster();
        }
        this.startShare = status;
      } else {
        this.shareFriends = status;
      }
    },

    createPoster() {
      // 生成海报
      // let poster = document.getElementById("poster");
      // 安卓浏览器样式错乱，改用clone
      var cloneDom = $("#poster").clone(true);
      cloneDom.css({
        position: "absolute",
        top: "0px",
        "z-index": "-1"
      });
      cloneDom.attr("id", "tmp_datatable");
      $("body").append(cloneDom);

      // html2canvas(poster, {
      html2canvas(cloneDom[0], {
        useCORS: true,
        backgroundColor: null,
        taintTest: true, // 在渲染前测试图片
        timeout: 500 // 加载延时
      })
        .then(canvas => {
          this.posterDataUrl = canvas.toDataURL();

          //销毁克隆对象
          cloneDom.empty();
          $("#tmp_datatable").remove();
        })
        .catch(err => {
          this.startShare = false;
          bi.message({
            tipText: "生成海报失败",
            type: "error"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.share_container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 50px;
  background-color: #fff;
  text-align: center;
  transition: all 0.3s;
  overflow: hidden;
}
.share_backbox {
  position: absolute;
  left: 5%;
  top: calc(50% - 50px);
  width: 90%;
  transform: translateY(-50%);
  user-select: none;
  pointer-events: none;
}
.share_background {
  padding-top: 79.8%;
  height: 0;
  @include abs_bg("mobile/share_bac.png");
}
.share_btn_group {
  position: absolute;
  bottom: 60px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;

  &::before,
  &:after {
    content: "";
    display: block;
  }
}
.share_button {
  display: inline-block;
  width: 6em;
  text-align: center;

  .txt {
    display: block;
    font-size: 12px;
    color: #44494f;
    opacity: 0.6;
    white-space: nowrap;
  }
}

.share_bg {
  display: block;
  width: 44px;
  height: 44px;
  margin: 0 auto 4px;
  border-radius: 50%;

  &.wechat_friends {
    @include abs_bg("mobile/wechat_friends.png");
  }
  &.wechart_moments {
    @include abs_bg("mobile/wechat_moments.png");
  }
  &.link {
    @include abs_bg("mobile/link.png");
  }
}

.modal_backdrop {
  z-index: 900;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  background: rgba(0, 0, 0, 0.6);
  text-align: center;
  &::after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 100%;
    opacity: 0;
  }
}
.poster_modal {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin: auto;
  width: 75%;
  // padding: 12px 6px;
  min-width: 270px;
  .poster_img {
    width: 100%;
    border-radius: 4px;
  }
  .poster_img_loading {
    width: 100%;
    height: 247px;
    background: #fff;
    border-radius: 4px;
    /deep/ .el-loading-mask {
      border-radius: 4px;
    }
  }
}
.poster_tips {
  margin-top: 8px;
  line-height: 1;
  font-size: 12px;
  color: #fff;
  opacity: 0.8;
}
.place_container {
  opacity: 0;
}

.poster_content {
  margin-top: 16px;
  text-align: center;
}
.qrcode_box {
  display: inline-block;
  padding: 2px 20px 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  .qrcode {
    margin-top: 8px;
  }
}

.poster_bottom {
  margin-top: 6px;
  line-height: 30px;
  font-size: 0;
  text-align: center;

  .logo {
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }
}
.wechat_share_friend_tips {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 12;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);

  .inner {
    width: 100%;
    height: 100%;
    background: url("~@/assets/images/mobile/save_tips.png") no-repeat center
      20px;
    background-size: 90%;

    .close_share_tips {
      width: 50px;
      height: 50px;
      position: absolute;
      left: 50%;
      top: 75%;
      margin-left: -10px;
      background: url("~@/assets/images/mobile/close.png") no-repeat center;
      background-size: 20px 20px;
    }
  }
}
.poster_container {
  margin: auto;
  width: 75%;
  // padding: 12px 6px;
  // padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 6px;
  padding-right: 6px;
  min-width: 270px;
  background: #fff;
  border-radius: 4px;
  color: $compon_dark_font_color;

  .poster_header {
    padding-left: 10px;
    display: flex;
    align-items: center;
    color: $input_dark_bac;
    .left {
      flex-shrink: 0;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      @include abs_bg("mobile/default_head.png");
    }
    .right {
      padding-left: 6px;
      display: flex;
      flex-direction: column;
      text-align: left;
      overflow: hidden;
      .info {
        color: $compon_dark_font_color;
      }
    }
  }
}
</style>